import React, { Component } from "react";
import CryptoJS from "crypto-js";
import { login, logout } from "store/user";
import store from "store.js";
// import "assets/styles/loginStyle.css";
import logo from "assets/img/logo.png"
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="login">
          <img
            src={logo}
            className="img-responsive"
            style="margin: 0 auto;"
          />
          <form
            action="/CareerApplicant/Account/LoginProcess"
            className="login-container"
            id="LoginForm"
            method="post"
            name="LoginForm"
          >
            <div className="form-group  has-feedback-left">
              <input
                className="form-control input-lg empty text-box single-line"
                id="HDUserId"
                name="HDUserId"
                placeholder="Username"
                type="text"
                value=""
              />
              <span className="field-validation-valid text-danger"></span>
            </div>
            <div className="form-group has-feedback-left">
              <input
                className="form-control input-lg empty"
                placeholder="Password"
                id="HDPassword"
                name="HDPassword"
                type="password"
              />
              <span className="field-validation-valid text-danger"></span>
            </div>
            <div className="">
              <button
                type="submit"
                id="btnSubmit"
                className="btn bg-blue btn-red btn-block c-o"
              >
                LOGIN
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default Login;
